import { CompanySize } from '@models/person/company.model'

/** Declarações do licitante registradas na inscrição (spec 045, requisitos 14 e 42). */
export enum SupplierEnrollmentNoticeDeclarationType {
	SMALL_BUSINESS_FRAMEWORK = 1,
	EPP_REVENUE_LIMIT = 2
}

export class SupplierEnrollmentNoticeDeclaration {
	id: string
	enrollmentId: string
	type: SupplierEnrollmentNoticeDeclarationType
	title?: string
	text: string
	textVersion: string
	companySize?: CompanySize
	declaredAt: string
	declaredBy: string
	ip?: string

	constructor(source?: Partial<SupplierEnrollmentNoticeDeclaration>) {
		if (source) {
			Object.assign(this, source)
		}
	}
}

export interface SupplierEnrollmentNoticeDeclarationText {
	type: SupplierEnrollmentNoticeDeclarationType
	title: string
	version: string
	text: string
}

/** Situação da declaração ME/EPP da inscrição: o portal oferece a quem é beneficiário e ainda não declarou. */
export class SmallBusinessDeclarationState {
	enrollmentId: string
	companySize?: CompanySize
	beneficiary = false
	declared = false
	texts: SupplierEnrollmentNoticeDeclarationText[] = []
	declarations: SupplierEnrollmentNoticeDeclaration[] = []

	constructor(source?: Partial<SmallBusinessDeclarationState>) {
		if (source) {
			Object.assign(this, source)
			this.texts = source.texts ?? []
			this.declarations = (source.declarations ?? []).map(it => new SupplierEnrollmentNoticeDeclaration(it))
		}
	}

	versionOf(type: SupplierEnrollmentNoticeDeclarationType): string | undefined {
		return this.texts.find(it => it.type === type)?.version
	}
}
